import { render, staticRenderFns } from "./ModifyInBox.vue?vue&type=template&id=0e723426&"
import script from "./ModifyInBox.vue?vue&type=script&lang=js&"
export * from "./ModifyInBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports